/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react'
import styled from '@emotion/styled'

import { DEFAULT_THEME_COLORS } from 'css/theme'
import RadioButton, { RadioButtonProps } from 'modules/ui/atoms/RadioButton'

export interface EcardProps extends RadioButtonProps {
  /** Image source */
  src: string
}

type EcardContainerProps = {
  src: string
  checked?: boolean
}

const EcardContainer = styled.div<EcardContainerProps>(
  {
    display: 'flex',
    justifyContent: 'center',
    alignContent: 'center',

    maxHeight: '120px',
    maxWidth: '180px',

    width: '100%',
    height: '100%',

    backgroundSize: 'cover',

    border: '2px solid',
    borderColor: DEFAULT_THEME_COLORS['--theme-color--neutral-90'],
    borderRadius: '8px',

    '&:focus': {
      borderRadius: '8px',
      outlineOffset: '2px',
    },

    '@media (max-width: 767px)': {
      maxWidth: '160px',
    },
  },
  ({ src, checked }) => {
    const styles: any = {
      backgroundImage: `url(${src})`,
    }

    if (checked) {
      styles.border = '2px solid'
      styles.borderColor = DEFAULT_THEME_COLORS['--theme-color--brand-primary']
      styles.boxShadow = '0px 0px 0px 1px #FFF inset'
    } else {
      styles['&:hover'] = {
        borderColor: DEFAULT_THEME_COLORS['--theme-color--neutral-70'],
        boxShadow: '0px 0px 0px 2px rgba(0, 0, 0, 0.12)',
        cursor: 'pointer',
      }
    }

    return styles
  },
)

const StyledEcardContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const StyledRadioButtonContainer = styled.div`
  margin: 1rem 0;
`

export const Ecard = (props: EcardProps) => {
  const { radioGroupName, src, checked = false, onChange, value } = props

  const handleClick = () => {
    onChange()
  }

  const handleChange = () => {
    onChange()
  }

  return (
    <StyledEcardContainer>
      <EcardContainer src={src} checked={checked} onClick={handleClick}>
        <div style={{ height: '120px', width: '180px' }} />
      </EcardContainer>
      <StyledRadioButtonContainer>
        <RadioButton
          value={value}
          dataId={`dedication-ecard-${value}`}
          radioGroupName={radioGroupName}
          checked={checked}
          onChange={handleChange}
          hasBorder={false}
        />
      </StyledRadioButtonContainer>
    </StyledEcardContainer>
  )
}
